export default "__VITE_ASSET__13d22848__"